import { BaseBackupPlan } from 'wizards/models/base/base-backup-plan-model';
import { Storages } from 'wizards/models/base/base-models/plan-storages-model';
import { RestorePlan } from 'wizards/models/base/restore-plan-model';
import { DiskVolumeView } from 'wizards/models/what-backup-models';
import { BackupDiskImagePlan } from './ibb-plan-model';
import { RestoreIbbBase } from './restore-ibb-base-model';

export class PlanResponseModel {
  plan: BackupDiskImagePlan | BaseBackupPlan | RestoreIbbBase | RestorePlan;
  Storages: Storages;
  DiskVolumes: DiskVolumeView[];
}
